import axios from "axios";
import { LMS_API } from "../src/config-global";

import https from "https";
import http from "http";

const httpsAgent = new https.Agent({
  keepAlive: true,
  timeout: 60000,
  scheduling: "fifo",
  maxSockets: 80,
  maxFreeSockets: 80,
});

const httpAgent = new http.Agent({
  keepAlive: true,
  timeout: 60000,
  scheduling: "fifo",
  maxSockets: 80,
  maxFreeSockets: 80,
});

const LmsBuildClient = axios.create({
  baseURL: LMS_API,
  timeout: 60000,
  httpsAgent,
  httpAgent
});

LmsBuildClient.interceptors.response.use(
  (res) => {
    if (res.data.errors) {
      console.error(
        res?.data?.errors[0]?.path,
        res.data.errors.map((x: any) => x.message).join("\n")
      );
    }
    return res;
  },
  (error) => {
    console.error("LmsClient", "interceptor", error);
  }
);

export default LmsBuildClient;
